export default {
  navigation_participant: [
    {
      title: "Home",
      href: "/",
      id: 0
    },
    {
      title: "My Plan",
      href: "/my-plan",
      id: 1,
      dependent: "planIsExist"
    },
    {
      title: "Sign Out",
      href: "",
      id: 4,
      action: "signOut",
      dependent: "isLogged"
    }
  ],

  navigation_guardian: [
    {
      title: "Home",
      href: "/",
      id: 0
    },
    {
      title: "Participants",
      href: "/my-participants",
      id: 2
    },
    {
      title: "Activity",
      href: "/activity",
      id: 3
    },
    {
      title: "Sign Out",
      href: "",
      id: 4,
      action: "signOut",
      dependent: "isLogged"
    }
  ],

  user_navigation: [
    {
      title: "Profile Info",
      href: "/profile",
      id: 0
    },
    {
      title: "Support Team",
      href: "/pre-plan/support-team",
      id: 1,
      action: "supportTeam"
    },
    {
      title: "Service Providers",
      href: "/service-providers",
      id: 2
    }
  ],

  footer_navigation: [
    {
      col: [
        {
          title: "Email",
          href: "mailto:info@resanec.com.au",
          external: true,
          id: "0_2"
        }
      ],
      colId: 0
    },
    {
      col: [
        {
          title: "Home",
          href: "/",
          external: false,
          id: "1_1"
        },
        {
          title: "My Plan",
          href: "/my-plan",
          external: false,
          id: "1_2"
        }
      ],
      colId: 1
    },
    {
      col: [
        {
          title: "Service Providers",
          href: "/service-providers",
          external: false,
          id: "2_1"
        },
        {
          title: "Invite Support Team",
          href: "/pre-plan/support-team",
          external: false,
          dependent: "userIsGuardian",
          id: "2_2"
        }
      ],
      colId: 2
    }
  ],

  authentication: {
    navigation: [
      {
        title: "Create An Account",
        href: "/sign-up",
        external: false,
        id: 0
      },
      {
        title: "Sign In",
        href: "/sign-in",
        external: false,
        id: 1
      }
    ]
  },

  messages: {
    global: {
      empty: "Field is empty"
    },

    email: {
      empty: "Field is empty",
      incorrect: "Email is incorrect",
      wrong: "We don’t recognise this email please re-enter it"
    },

    password: {
      empty: "Field is empty",
      length: "Password must be at least 6 characters long",
      incorrect: "Password is incorrect",
      wrong: "Your password is incorrect, click “Forgot password” to reset it.",
      isNotEqual: "Passwords don't match"
    },

    checkbox: {
      isNotChecked: "Is not checked"
    }
  },

  relationship_labes: {
    S: "Spouse",
    P: "Parent",
    C: "Child",
    E: "Extended Family",
    F: "Friend"
  },

  frequency_labels: {
    D: "Day",
    W: "Week",
    F: "Fortnight",
    M: "Month",
    Y: "Year"
  },

  api: {
    base: process.env.REACT_APP_API_BASE
  },

  roles: {
    Participant: 110,
    Guardian: 120
  },

  plan_section: {
    AM: "About Me",
    CA: "Community Activities",
    MG: "My Goals",
    RS: "Recurring Services",
    "RS-OOP": "One Off Purchase",
    "RS-RP:": "Recurring Purchase",
    "RS-RA": "Recurring Activity",
    "RS-WA": "Weekly Activity"
  }
}
